<template>
  <div :class="['small-prints', flowStyles && 'small-prints--flow-styles']">
    <LeapYearSmallPrint />
    <BoogoSmallPrint />
  </div>
</template>

<script>
import LeapYearSmallPrint from '@/components/flow/small-prints/LeapYearSmallPrint.vue'
import BoogoSmallPrint from '@/components/flow/small-prints/BoogoSmallPrint.vue'

export default {
  components: { LeapYearSmallPrint, BoogoSmallPrint },
  name: 'SmallPrint',
  props: {
    flowStyles: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.small-prints {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  margin-bottom: 60px;
  @include tablet {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 60px;
    align-self: stretch;
  }
  ul {
    margin: 0;
    padding-left: 15px;
    line-height: 12px;
    li {
      line-height: 12px;
      margin-bottom: 10px;
      &::marker {
        color: var(--boulder);
      }
    }
  }
  &__content {
    flex: 1 0 0;
  }
  &__content:first-child {
    @include tablet {
      max-width: 296px;
    }
  }
  &__title {
    color: var(--gray-9);
    font-size: rem(10px);
    font-style: normal;
    font-weight: 700;
    line-height: rem(12px);
  }
  &__text {
    color: var(--boulder);
    font-size: rem(10px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(12px);
  }
  &__link {
    color: var(--light-purple);
    font-size: rem(10px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(12px);
  }
  &--flow-styles {
    margin-top: 30px;
  }
}
</style>
